import { OptionItem } from "app/model";


export { OptionItem } from "app/model";
export interface CDFTTable {
    id: string;
    wellStringId: string;
    wellLongName: string;
    fieldLongName: string;
    platformLongName: string;
    stringShortName: string;
    stringLongName: string;
    tester: string;
    result: string;
    status: string;
    date: string;
    inputDate: string;
}

export interface XmasTree {
    id: string;
    wellStringId: string;
    oem: string;
    model: string;
    sizeIn: number;
    ratingPsi: number;
    manufacturer: string;
    partNo: string;
    installedDate: string;
    status: string;
    remark: string;
    treecapConn: string;
    treecapConnRemarks: string;
    treeCapConnSize: number;
    treeCapConnThread: string;
    createdAt: string;
}

export interface SceValve {
    id: string;
    mdSceValveTypeId: string;
    oem: string;
    model: string;
    sizeIn: number;
    ratingPsi: number;
    manufacturer: string;
    partNo: string;
    installedDate: string;
    isActuated: boolean;
    equipmentBrand: string;
    actuatorModel: string;
    actuatorType: string;
    openingCm: number;
    closingCm: number;
    openingSec: number;
    closingSec: number;
    fullyClose: number;
    fullyOpen: number;
    jammed: number;
    allowLeakRatePsi10mins: number;
    status: string;
    remark: string;
    sceXmasTreeId: string;
    hydraulicReturn: number;
    createdAt: string;
}

export interface WellHead {
    id: string;
    wellStringId: string;
    oem: string;
    model: string;
    equipmentBrand: string;
    sizeIn: number;
    ratingPsi: number;
    manufacturer: string;
    partNo: string;
    installedDate: string;
    status: string;
    remark: string;
    isActuated: boolean;
    actuatorModel: string;
    actuatorType: string;
    hydraulicReturn: number;
    openingCm: number;
    closingCm: number;
    openingSec: number;
    closingSec: number;
    fullyOpen: number;
    fullyClose: number;
    jammed: number;
    allowLeakRatePsi10mins: number;
    mdSceValveTypeId: string;
    createdAt: string;
}

export interface Scssv {
    id: string;
    wellStringId: string;
    mdSssvTypeId: string;
    oem: string;
    model: string;
    sizeIn: number;
    ratingPsi: number;
    manufacturer: string;
    partNo: string;
    installedDate: string;
    equipmentBrand: string;
    hydraulicReturn: number;
    isLockedOpen: boolean;
    slamTest: number;
    clPressure: number;
    blowingGas: boolean;
    isSelfEqualize: boolean;
    cycling: number;
    status: string;
    remark: string;
}

export interface Wrsv {
    id: string;
    scssvId: string;
    oem: string;
    model: string;
    equipmentBrand: string;
    sizeIn: number;
    ratingPsi: number;
    manufacturer: string;
    partNo: string;
    initialInstalledDate: string;
    latestInstalledDate: string;
    subsequentInstalledDate: string;
    installationDepth: number;
    installationAtSvlntrsv: string;
    trsvType: string;
    status: string;
    remark: string;
}
export interface StringEquipment {
    wellStringId: string;
    wellName: string;
    xmasTree: XmasTree;
    kwValve: SceValve;
    lmValve: SceValve;
    cValve: SceValve;
    ssValve: SceValve;
    wValve: SceValve;
    annulusA: WellHead;
    annulusB: WellHead;
    annulusC: WellHead;
    annulusD: WellHead;
    scssv: Scssv;
    wrsv: Wrsv;
}

export interface WellStringStatus {
    id: string;
    wellStringId: string;
    platformShortName: string;
    platformLongName: string;
    fieldShortName: string;
    fieldLongName: string;
    wellShortName: string;
    wellLongName: string;
    stringShortName: string;
    stringLongName: string;
    stringIndicatorShortName: string;
    wellStringType: string;
    stringIndicator: string;
    wellFlowCategory: string;
    prodStatus: string;
    lastUpdatedBy: string;
    lastUpdatedDate: string;
}

export enum ValveEnum {
    WV = 'wValve',
    CV = 'cValve',
    SSV = 'ssValve',
    LMV = 'lmValve',
    KWV = 'kwValve',
    annulusA = 'annulusA',
    annulusB = 'annulusB',
    annulusC = 'annulusC',
    annulusD = 'annulusD',
}

export enum CdftStatus {
    DRAFT = 'Draft',
    APPROVED = 'Approved',
    REVIEWED = 'Reviewed',
    READY = 'Ready to Review',
    REJECTED = 'Rejected'
}

export enum WfamStatus {
    HEALTHY = 'Healthy',
    UNHEALTHY = 'Unhealthy',
}

export type ValveType =
    | 'wValve'
    | 'cValve'
    | 'ssValve'
    | 'lmValve'
    | 'kwValve'
    | 'annulusA'
    | 'annulusB'
    | 'annulusC'
    | 'annulusD';


export interface ValveOptionType {
    items: OptionItem[];
}

export interface CdftRecord {
    id: string;
    result: any;
    status: string;
    date: string;
    preparedBy: string;
    reviewedBy: string;
    approvedBy: string;
    approvedDate: string;
    reviewedDate: string;
    wfamStatus: string;
    remarks: string;
    overallRemarks: string;
}

export interface CDFT extends CdftRecord {
    cdftHeader: CDFTHeader;
    cdftXmtWhvTest: CdftXmtWhvTest[];
    cdftSssvDbt: CdftSssvDbt;
    cdftAnnulusPressureReport: CdftAnnulusPressureReport;
    cdftControlLineTest: CdftControlLineTest[];
    cdftSubsidenceMonitoring: CdftSubsidenceMonitoring;
}

export interface CDFTHeader {
    id: string;
    wellStringId: string;
    wellStatus: string;
    productionRateBblDay: any;
    injectionRateMmscfD: any;
    shutInTimeHrs: any;
    tester: string;
    date: string;

    xmtRating: string;
    xmtSize: string;
    xmtOem: string;
    isGasLiftedWell: boolean;
    gasLiftedHeader: string;

    // Annulus
    fthp: any;
    sithp: any;
    pcp: any;
    icp: any;
    scp: any;
    ccp: any;
    header: string;

    stringStatus: string;
    stringIndicator: string;

    treeCapConn: string;
    size: string;
    thread: string;
    treeCapCond: string;
    treecapConnRemarks: string
    treecapCondRemarks: string

    imposedPressure: string
    isImposedPressure: boolean

    voidArea: any;
    voidAreaAfter: any;

    isPressureBuildUpTest: boolean;
    pressureBuildUpTest: any;
    xmtPhysCond: string;
    wellheadPhysCond: string;

    cdftAttachments: HeaderAttachment[];
}

export interface HeaderAttachment {
    cdftAttachmentId: string;
    file: any;
    url: string;
    name: string;
}

export interface CdftXmtWhvTest {
    id: string;
    mdSceValveTypeId: string;
    sizeIn: number;
    equipmentBrand: string;
    actuatorModel: string;
    actuatorType: string;
    oem: string;
    ratingPsi: number;
    openingSec: number;
    openingCm: number;
    closingSec: number;
    closingCm: number;
    valvedTest: string;
    remarks: string;
    finding: string;
    fullyOpen: number;
    fullyClose: number;
    jammed: number;
    hydraulicReturn: number;
    greasing: number;
    greasingType: string;
    flusing: number;
    flusingType: string;
    sealing: number;
    sealingType: string;
    actualLeakRate: number;
    cdftXmtWhvGreasing: CdftXmtWhvGreasing[];
}

export interface CdftXmtWhvGreasing {
    id: string;
    type: string;
    time0: number;
    time1: number;
    time2: number;
    time3: number;
    time4: number;
    time5: number;
    time6: number;
    time7: number;
    time8: number;
    time9: number;
    time10: number;
    result: string;
    cdftXmtWhvTestId: string;
}

export interface CdftSssvDbt {
    id: string;
    cdftRecordId: string;
    purposeFunctTest: string;
    typeOfDownhole: string;
    pressureBleedOff: string;
    pressureBleedOffPsi: number;
    thp: number;
    isSssvSelfEqualizing: boolean;
    typeOfDownholeBarrier: string
    wrsvType: string;
    wrsvOem: string;
    wrsvSize: number;
    installationAt: string;
    installationDepth: number;
    isSsv: boolean;
    ssvOem: string;
    ssvSize: number;
    cyclingTest: number;
    clPressure: number;
    hydReturn: number;
    slamTest: boolean;
    blowingGas: boolean;
    openingIndication: boolean;
    closingIndication: boolean;
    openingIndicationPsi: number;
    closingIndicationPsi: number;
    valveLeakRate: number;
    finalWellStatus: string;
    sssvResult: string;
    cdftTimeTubingPressure: CdftTimeTubingPressure[];
}

export interface CdftTimeTubingPressure {
    id: string;
    cdftSssvDbtId: string;
    timeAfterShutIn: number;
    tubingPressure: number;
    pcpAnnulus: number;
    pclPsi: number;
    sclPsi: number;
    voidAreaPsi: number;
}

export interface CdftAnnulusPressureReport {
    id: string;
    cdftRecordId: string;
    result: string;
    remarks: string;
    cdftAnnulusPressureReportDetails: CdftAnnulusPressureReportDetails[];
}

export interface CdftAnnulusPressureReportDetails {
    id: string;
    cdftAnnulusPressureReportId: string;
    time: number;
    pcpAAnnulusPsi: number;
    icpBAnnulusPsi: number;
    scpCAnnulusPsi: number;
    ccpDAnnulusPsi: number;
    thpPsi: number;
}

export interface CdftControlLineTest {
    id: string;
    cdftRecordId: string;
    controlLineType: string;
    valveTest: string;
    remarks: string;
    clInitialPressure: number;
    clTestedPressure: number;
    clPressureAfterTest: number;
    hydraulicReturn: number;
    blowingGas: boolean;
    periodOfTesting: number;
    svlnInstalled: boolean;
    clTestedResult: string;
}

export interface CdftSubsidenceMonitoring {
    id: string;
    cdftRecordId: string;
    pcvPoint1: number;
    icvPoint2: number;
    scvPoint2: number;
    ccvPoint3: number;
    result: string;
    remark: string;
}

export interface WellString {
    id: string;
    wellId: string;
    wellboreId: string;
    stringLongName: string;
    stringShortName: string;
    stringStatus: string | null;
    stringIndicatorLongName: string;
    stringIndicatorShortName: string;
    reservoirZone: string | null;
    tubingSize: number;
    inputDate: string;
    inputBy: string;
    updateDate: string;
    updateBy: string;
    isDeleted: boolean;
    activityPlans: any[];
    cmBaseEmergings: any[];
    pmCdftResults: any[];
    pmRegisters: any[];
    sceScssvs: any[];
    sceWellHeads: any[];
    sceXmasTrees: any[];
    scssvMaintenances: any[];
    well: any | null;
    wellFlowCategories: any[];
    wellProductionStatuses: any[];
    wellTypes: any[];
    wellbore: any | null;
    wpbDetails: any[];
    cdftHeaders: any[];
    dailyActivityTrackers: any[];
    wrsvRegisters: any[];
    annulusPressureRecords: any[];
    aprRegisters: any[];
    cmRegisters: any[];
    failureNotifications: any[];
    wellHealthinesses: any[];
    correctiveMaintenances: any[];
}
